import styled, { css } from 'styled-components';
import { SpinnerIcon } from '../../icons/SpinnerIcon';

interface StyledButtonProps {
  $width: string;
}

const StyledButton = styled.button<StyledButtonProps>(
  ({ theme, $width }) => css`
    border: none;
    padding: 0.5rem;
    border-radius: 0.5rem;
    background: ${theme.paper.default};
    color: ${theme.text.default};
    width: ${$width};
    min-width: 80px;
    transition: background 0.2s ease;
    font-weight: 600;
    border: solid 1px ${theme.border.default};

    &:hover:not(:disabled) {
      background: ${theme.paper.hover};
      cursor: pointer;
    }

    &:disabled {
      color: ${theme.text.disabled};
      font-weight: 400;
    }

    &:focus-visible {
      outline: 1px solid ${theme.border.focus};
      outline-offset: 2px;
    }
  `
);

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  width?: string;
  isPending?: boolean;
}

export function Button({
  children,
  disabled,
  width = 'auto',
  isPending,
  type = 'button',
  ...rest
}: ButtonProps) {
  return (
    <StyledButton
      {...rest}
      aria-live={type === 'submit' ? 'polite' : 'off'}
      aria-label={isPending ? 'Submitting form' : undefined}
      $width={width}
      disabled={disabled || isPending}
    >
      {isPending ? <SpinnerIcon /> : children}
    </StyledButton>
  );
}
